import { callAPI } from '../network';

export async function getEmployeesWithProfiles (companyId){
  
   const data = await callAPI(
                        null, 
                        `ManagementEmployee/GetEmployeesWithProfiles?companyId=${companyId}`, 'get');
   return data || [ ];
}

export async function getProfiles (){
  
   const data = await callAPI(
                        null, 
                        'ManagementProfile', 'get');
   return data || [ ];
}

export async function getProfileById (id){

    const data = await callAPI(
                         null, 
                         'ManagementProfile/GetById?id='+ id, 'get');
    return data;
 }

 export async function saveEmployee (customer){
   const method = customer.id ? 'put' : 'post';
   //console.log(customer);
   const data = await callAPI(
                        customer, 
                        'ManagementProfile', method);
   return data;
}

export async function getAllEmployeesByAirport(airportId, companyId){
   const url = airportId
      ? `ManagementEmployee/GetAllEmployeesByAirport?companyId=${companyId}&airportId=${airportId}`
      : `ManagementEmployee/GetAllEmployeesByAirport?companyId=${companyId}`;
   const data = await callAPI(null, url, 'get');
   return data;
}


export async function getAllDataEmployeesByAirport(id){

   const data = await callAPI(
                        null, 
                        'ManagementEmployee/GetAllDataEmployeesByAirport?AirportID=' + id, 'get');
   return data;
}

export async function getAllEmployeesByAirportForEdit(airportId, companyId){
   const url = airportId
      ? `ManagementEmployee/GetAllEmployeesByAirportForEdit?companyId=${companyId}&airportId=${airportId}`
      : `ManagementEmployee/GetAllEmployeesByAirportForEdit?companyId=${companyId}`;
   const data = await callAPI(null, url, 'get');
   return data;
}

export async function savePermissions (permissions,profileId,profileName){
   const params = {
         permission: permissions.permissions.map(permission => ({
         Code: permission.Code, // Asegúrate de usar la capitalización correcta, como aparece en el objeto.
         Description: permission.Description, // Igualmente aquí.
         Id: permission.Id
       })),
       profileId: profileId,
       profileName: profileName
    };
    //console.log('entro');
   //console.log(params);
   const data = await callAPI(
      params, 
            'Security/updatePermissionsByProfile', 'post');
return data || [ ];
}

export async function deleteProfile (id){
   const data = await callAPI(
                        null, 
                        'ManagementProfile?id='+ id, 'delete');
   return data;
}

export async function getAllProfilesByEmployee(employeeId, companyId){
   const url = companyId
      ? `ManagementEmployee/getProfilesByEmployee?employeeId=${employeeId}&companyId=${companyId}`
      : `ManagementEmployee/getProfilesByEmployee?employeeId=${employeeId}`;
   const data = await callAPI(null, url, 'get');
   return data || [];
}

export async function getAllPermissionsByProfile(profileId){
   let data;
   if (profileId) {
      data = await callAPI(
         null, 
         'Security/getPermissionsByProfile?profileId='+ profileId, 'get');

      
   } else {
      data = await callAPI(
         null, 
         'Security/getAllPermissionsByProfile', 'get');

   }
  
   return data || [ ];
}


export async function updateProfilesByEmployee (profiles, employee ){

   //console.log(profiles);
   const params = {
      profiles: profiles.profiles.map(profile => ({
         Id: profile.Id, // Asegúrate de usar la capitalización correcta, como aparece en el objeto.
         Description: profile.Description // Igualmente aquí.
       })),
       employeeId: profiles.employeeId,
       employee: employee
    };

   
   const data = await callAPI(
                  params, 
                        'ManagementEmployee/updateProfilesByEmployee', 'post');
   return data || [ ];
}

export async function bulkUpdateAirportsByEmployees(employeeIds, airports, employee) {
   const params = {
      employeeIds,
      airports: airports.map(a => ({ Id: a.Id, Code: a.Code })),
      employee
   };
   const data = await callAPI(params, 'ManagementEmployee/bulkUpdateAirportsByEmployees', 'post');
   return data;
}

export async function bulkUpdateProfilesByEmployees(employeeIds, profiles, employee) {
   const params = {
      employeeIds,
      profiles: profiles.map(p => ({ Id: p.Id, Description: p.Description })),
      employee
   };
   const data = await callAPI(params, 'ManagementEmployee/bulkUpdateProfilesByEmployees', 'post');
   return data;
}

export async function deleteEmployeeByProfile (id, employee){
   const data = await callAPI(
                        null, 
                        `ManagementEmployee/deleteProfilesByEmployee?employeeId=${id}&employee=${employee}`, 'get');
   return data;
}
